import { Component, ViewChild } from '@angular/core';

const KEY_TAB = 9;
const ENTER = 13;
const ARROW_RIGHT = 39;
const ARROW_LEFT = 37;

@Component({
  standalone: false,
    selector: 'mm-input-cell-editor',
    templateUrl: './input-cell-editor.component.html',
})

export class InputEditorComponent {
    @ViewChild('inputShares') textInput: any;
    params: any;

    agInit(params: any): void {
        this.params = params;
    }

    afterGuiAttached() {
        this.textInput.nativeElement.focus();
    }

    getValue() {
        return this.textInput.nativeElement.value;
    }

    onKeyPress(event: any) {
        if (!isNumeric(event)) {
            event.preventDefault();
        }
        function isNumeric(event: any) {
            return !!/\d/.test(event.key) || !!/\./.test(event.key);
        }
    }

    onKeyDown(event: any) {
        if (event.keyCode === ARROW_RIGHT ||
            event.keyCode === ARROW_LEFT ||
            event.keyCode === KEY_TAB || event.keyCode === ENTER
        ) {
        }
    }
}